import {
  CampaignData,
  LoginResponse,
  MeusNumerosResponse,
  RegisterPayload,
} from "../types";

/** URL base da API da plataforma EAD (login). */
const API_URL = process.env.REACT_APP_API_URL ?? "https://api.academiarafaeltoro.com.br";

/** URL base da API da promoção (ms-carona). */
const CARONA_API_URL = process.env.REACT_APP_CARONA_API_URL ?? "https://ms-carona.academiarafaeltoro.com.br";

/** Erro de requisição carregando o status HTTP para tratamento no front. */
export class ApiError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

  if (!response.ok) {
    throw new ApiError(response.status, `Erro na requisição: ${response.status}`);
  }

  return response.json() as Promise<T>;
}

export function getCampaign(): Promise<CampaignData> {
  return request<CampaignData>(`${API_URL}/campaign`);
}

export function registerParticipant(payload: RegisterPayload): Promise<void> {
  return request<void>(`${API_URL}/register`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

/**
 * Autentica o usuário na API da plataforma EAD e retorna o token Bearer.
 */
export function login(email: string, password: string): Promise<LoginResponse> {
  return request<LoginResponse>(`${API_URL}/login`, {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

/**
 * Busca as participações e números da sorte do dono do token na API da promoção.
 */
export function getMeusNumeros(token: string): Promise<MeusNumerosResponse> {
  return request<MeusNumerosResponse>(`${CARONA_API_URL}/api/meus-numeros`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
